import { Prisma } from '@repo/database/src/types';
import type { CountrySubdivision } from '@repo/database/src/types';
import { Type } from 'class-transformer';
import { IsEnum, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { PaginationOptionsDto } from '../../pagination-options-types';

/**
 * Filter DTO for countries in the admin dashboard
 */
export class AdminCountriesFilterDto {
  @IsOptional()
  @IsString()
  search?: string;

  @IsOptional()
  @IsString()
  code?: string;

  @IsOptional()
  @IsString()
  regionName?: string;

  @IsOptional()
  @IsEnum(['true', 'false'])
  hasSubdivisions?: 'true' | 'false';

  @IsOptional()
  @IsString()
  subdivisionName?: string;
}

/**
 * Main DTO for getting countries list with filters, pagination, and sorting
 */
export class GetAdminCountriesDto extends PaginationOptionsDto {
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => AdminCountriesFilterDto)
  filter?: AdminCountriesFilterDto;

  @IsOptional()
  sorts?: Array<{ field: string; order: Prisma.SortOrder }>;
}

/**
 * Response DTO for countries list with computed fields
 */
export interface AdminCountryInfoDto {
  // Country information
  id: string;
  name: string;
  code: string;
  createdAt: string;
  updatedAt: string;

  // Subdivision information
  subdivisions: CountrySubdivision[];
  subdivisionsCount: number;

  // Region assignments
  regions: Array<{
    id: string;
    name: string;
  }>;
  regionsCount: number;

  // Computed fields
  hasSubdivisions: boolean;
}

/**
 * Response DTO for admin countries list
 */
export interface AdminCountriesResponseDto {
  countries: AdminCountryInfoDto[];
  totalCount: number;
}
